module.exports = __webpack_public_path__ + "Yfz3EKkuEAXohMTFW/warning.svg";